import { render, staticRenderFns } from "./customButtonOutline.vue?vue&type=template&id=6856d931&scoped=true"
import script from "./customButtonOutline.vue?vue&type=script&lang=js"
export * from "./customButtonOutline.vue?vue&type=script&lang=js"
import style0 from "./customButtonOutline.vue?vue&type=style&index=0&id=6856d931&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6856d931",
  null
  
)

export default component.exports